<template>
    <div class="flex flex-col gap-3 py-7 px-5 bg-white border border-valence-grey-300 rounded-lgr w-full md:w-auto md:min-w-60 md:max-w-72 md:grow">
        <div class="body-small">{{ title }}</div>
        <div class="h-px bg-valence-grey-250"></div>
        <SkeletonLoader v-if="isLoading" class="h-14 w-full rounded-lgr" />
        <div v-else class="py-3">
            <span class="title-section p-3 rounded-lgr" :style="{ backgroundColor: getColor(color) }">
                {{ value }}
            </span>
        </div>
        <SkeletonLoader v-if="isLoading" class="h-5 w-full rounded-lgr" />
        <div v-else class="body-small">{{ caption }}</div>
    </div>
</template>

<script setup lang="ts">
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";

import { FeedbackStatColor } from "./types";

const {
    title = "",
    value = "",
    caption = "",
    color = FeedbackStatColor.Green,
    isLoading = false,
} = defineProps<{
    title?: string;
    value?: string | number;
    caption?: string;
    color?: FeedbackStatColor;
    isLoading?: boolean;
}>();

const getColor = (colorName?: FeedbackStatColor): string => {
    switch (colorName) {
        case FeedbackStatColor.Green:
            return "rgba(149, 197, 135, 0.53)";
        case FeedbackStatColor.Blue:
            return "rgba(145, 211, 225, 0.55)";
        case FeedbackStatColor.Yellow:
            return "rgba(255, 211, 168, 0.59)";
        default:
            return "#F0F0F0";
    }
};
</script>
